/**
 * 0~10 등 점수 UI 표시용: 소수점 첫째 자리까지 (반올림)
 *
 * 존 경계(3.0/5.0/8.0)를 넘겨 올리지 않게 내림으로 바꾼 적이 있다. 7.96이
 * "8.0"으로 보이면 '완벽해' 구간처럼 읽힌다는 이유였는데, 되돌렸다.
 * 점수와 존 이름을 함께 보여주는 화면이 없어서(존 이름은 기록 작성 화면의
 * 버튼에만 있고 점수 범위가 안 붙는다) 보는 사람은 경계를 알지 못한다.
 * 전체 1,206건 중 해당하는 것도 1건뿐이었다. 규칙을 비틀 이유가 못 된다.
 *
 * 랭킹에서 순서가 뒤집혀 보이던 문제는 존 재배치(MainRanking)로 해결했다.
 */
export function formatScoreOneDecimal(
  value: number | string | null | undefined
): string {
  if (value === null || value === undefined || value === '') {
    return '-'
  }

  const n = typeof value === 'number' ? value : Number(value)

  if (!Number.isFinite(n)) {
    return '-'
  }

  return roundToOneDecimal(n).toFixed(1)
}

/**
 * 소수 첫째 자리로 반올림한다.
 *
 * 왜 toFixed(1)을 그대로 쓰지 않나
 * -------------------------------
 * toFixed는 2진수로 저장된 실제 값을 기준으로 자른다. 그런데 9.95는 2진수로
 * 정확히 표현되지 않아 실제로는 9.9499999999999992895다. 그래서
 * (9.95).toFixed(1) 이 "10.0"이 아니라 "9.9"가 된다.
 *
 * 눈에 보이는 문제였다. 랭킹 1위 점수가 9.95인데 화면엔 9.9로 떴다.
 * 존 안에서 순위를 펼치는 계산상 1위는 상한(10)에 아주 가까운 값이 나오는데,
 * 하필 그 값이 이 함수에서 한 칸 내려앉았다.
 *
 * 곱셈(n * 10)도 같은 종류의 오차를 만들 수 있어서, 자릿수 이동을 문자열로
 * 한다. 문자열을 숫자로 읽는 단계에서 지수가 적용되므로 곱셈 오차가 없다.
 * ('9.95e1' → 99.5)
 */
function roundToOneDecimal(n: number): number {
  const shifted = Number(`${n}e1`)
  if (!Number.isFinite(shifted)) {
    // 지수 표기(1e21 등)처럼 위 방식이 통하지 않는 값은 원래대로 둔다
    return n
  }
  const back = Number(`${Math.round(shifted)}e-1`)
  return Number.isFinite(back) ? back : n
}
